import api from '../utils/axiosConfig';

export const studentGoogleLogin = async (tokenObj) => {
    try {
      const response = await api.post('/accounts/google-login/', tokenObj);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  };
  

  export const adminGoogleLogin = async (tokenObj) => {
    try {
      const response = await api.post('/accounts/pu_admin/login/', tokenObj);
      return response.data;
    } catch (error) {
      console.error('Login error details:', error);
      // More defensive error handling
      throw {
        message: error?.response?.data?.message || error?.message || 'Login failed',
        status: error?.response?.status || 500
      };
    }
  };
  
export const completeRegistration = async (userData) => {
  try {
    const response = await api.post('/accounts/complete-registration/', userData);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getStudentProfile = async () => {
  try {
    const response = await api.get('/accounts/profile/');
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const listStudents = async () => {
  try {
    const response = await api.get('/accounts/pu_admin/students/');
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateStudentPortalAccess = async (studentEmails) => {
  try {
    const response = await api.patch('/accounts/pu_admin/can_access_portal/', {
      student_emails: studentEmails
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};